import { atoms } from '../../css/atoms/atoms.css';

export const ListItemIcon: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <span
      className={atoms({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: 'medium',
      })}
    >
      {children}
    </span>
  );
};
